import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import './CustomModal.css';

export class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('scroll', this.handleScroll, true);
    // Lock body scroll when modal is open
    if (this.props.visible) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        document.body.style.overflow = 'hidden';
        // Focus modal for accessibility
        if (this.modalRef.current) {
          this.modalRef.current.focus();
        }
      } else {
        document.body.style.overflow = '';
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('scroll', this.handleScroll, true);
    document.body.style.overflow = '';
  }

  handleScroll = (event) => {
    if (event.target.classList && event.target.classList.contains('custom-modal-body')) {
      if (document.activeElement && document.activeElement.closest('.ant-picker')) {
        document.activeElement.blur();
      }
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.props.visible) {
      const activeClose = this.props.onClose || this.props.onCancel;
      if (activeClose) {
        activeClose();
      }
    }
  };

  handleBackdropClick = (event) => {
    if (event.target === event.currentTarget && this.props.maskClosable !== false) {
      const activeClose = this.props.onClose || this.props.onCancel;
      if (activeClose) {
        activeClose();
      }
    }
  };

  render() {
    const {
      visible,
      title,
      children,
      width = '1000px',
      onClose,
      onCancel,
      destroyOnClose = true,
      bodyStyle = {},
    } = this.props;

    const activeClose = onClose || onCancel;

    if (!visible && destroyOnClose) {
      return null;
    }

    return createPortal(
      <div
        className={`custom-modal-overlay ${visible ? 'active' : ''}`}
        onClick={this.handleBackdropClick}
      >
        <div
          ref={this.modalRef}
          className={`custom-modal-content-wrapper ${visible ? 'active' : ''}`}
          style={{ maxWidth: width }}
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          aria-labelledby="custom-modal-title"
        >
          {/* Modal Header */}
          <div className="custom-modal-header">
            <h3 id="custom-modal-title" className="custom-modal-title-text">
              {title}
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div id="custom-modal-header-extra" style={{ display: 'flex', alignItems: 'center' }} />
              <button
                type="button"
                className="custom-modal-close-btn"
                onClick={activeClose}
                aria-label="Close modal"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>

          {/* Modal Body */}
          <div className="custom-modal-body" style={{ background: "#fff", ...bodyStyle }}>
            {(!visible && !destroyOnClose) ? null : children}
          </div>
        </div>
      </div>,
      document.body
    );
  }
}
